<div class="scroll-holder">
    <div class="scroll-tray">
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/AKS_0598.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/IMG_20221127_092319.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg+1.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg+4+.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg2.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg5.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg6.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg8.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/AKS_0598.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/IMG_20221127_092319.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg+1.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg+4+.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg2.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg5.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg6.webp" alt="">
        </div>
        <div class="images">
            <img src="https://eureka2023.s3.ap-south-1.amazonaws.com/gallery/Pg8.webp" alt="">
        </div>
    </div>
</div>

<!-- <div class="scroll-holder1">
    <div class="scroll-tray1">
        <div class="images">
            <img src="assets/zonals/Mumbai.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/bangalore.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Delhi.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Mumbai.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/bangalore.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Delhi.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Mumbai.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/bangalore.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Delhi.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Mumbai.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/bangalore.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Delhi.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Mumbai.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/bangalore.png" alt="">
        </div>
        <div class="images">
            <img src="assets/zonals/Delhi.png" alt="">
        </div>
    </div>
</div> -->